import { render } from "./PhotoSelectorModal.vue?vue&type=template&id=11afc77b"
import script from "./PhotoSelectorModal.vue?vue&type=script&lang=js"
export * from "./PhotoSelectorModal.vue?vue&type=script&lang=js"

import "./PhotoSelectorModal.vue?vue&type=style&index=0&id=11afc77b&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__